<template>
    <j-page class="j-style-demo-layout">
        <div slot="table" class="j-style-demo-layout-srcoll">
            <el-card shadow="hover">
                <label slot="header">主题色</label>
                <el-divider content-position="left">主题色板</el-divider>
                <el-row>
                    <div class="color-level">
                        <span v-for="(level, i) in color" :key="i" :class="['theme'+ level]" />
                    </div>
                    <div class="color-level">
                        <span v-for="(level, i) in color" :key="i" :class="['danger'+ level]" />
                    </div>
                    <div class="color-level">
                        <span v-for="(level, i) in color" :key="i" :class="['success'+ level]" />
                    </div>
                    <div class="color-level">
                        <span v-for="(level, i) in color" :key="i" :class="['warn'+ level]" />
                    </div>
                    <div class="color-level">
                        <span v-for="(level, i) in color" :key="i" :class="['info'+ level]" />
                    </div>
                </el-row>
            </el-card>

            <el-card shadow="hover">
                <label slot="header">按钮</label>
                <el-divider content-position="left">按钮样式</el-divider>
                <el-switch class="margin10" v-model="disabled" active-text="禁用" inactive-text="启用" />
                <el-row>
                    <el-button type="info" :disabled="disabled">取消</el-button>
                    <el-button type="info" icon="el-icon-folder-add" :disabled="disabled">导入</el-button>
                    <el-button type="info" icon="el-icon-folder-remove" :disabled="disabled">导出</el-button>
                    <el-button type="info" icon="el-icon-refresh" :disabled="disabled">重置</el-button>
                    <el-button icon="el-icon-search" type="primary" :disabled="disabled">搜索</el-button>
                    <el-button icon="el-icon-plus" type="warning" :disabled="disabled">新增</el-button>
                </el-row>
                <el-row class="margin10">
                    <el-button type="text" class="common-button-detail" :disabled="disabled">详情</el-button>
                    <el-button type="text" class="common-button-edit" :disabled="disabled">编辑</el-button>
                    <el-button type="text" class="common-button-del" :disabled="disabled">删除</el-button>
                    <el-button type="text" class="common-button-add" :disabled="disabled">新增</el-button>
                </el-row>
            </el-card>

            <el-card shadow="hover">
                <label slot="header">分页</label>
                <el-row>
                    <el-pagination
                            :current-page="query.page"
                            :page-size="query.limit"
                            :total="100"
                            :background="pmxBackground"
                            :pager-count="pmxCount"
                            :layout="pmxLayout"
                            :pageSizes="pmxSizes"
                            @current-change="changePage"
                            @size-change="sizeChange"
                    />
                </el-row>
            </el-card>

            <el-card shadow="hover">
                <label slot="header">Form表单样式</label>
                <el-row>
                    <el-form style="width: 500px" :model="dgmxForm" :rules="dgmxRule" :label-width="dgmxFormLabelWidth">
                        <el-form-item label="输入框" prop="input">
                            <el-input v-model.trim="dgmxForm.input" placeholder="请输入" maxlength="10" show-word-limit clearable />
                        </el-form-item>
                        <el-form-item label="描述" prop="description">
                            <el-input v-model.trim="dgmxForm.description" type="textarea" :rows="3" placeholder="请输入描述" maxlength="200" show-word-limit clearable />
                        </el-form-item>
                        <el-form-item label="选择" prop="select">
                            <el-select v-model="dgmxForm.select" placeholder="请选择" style="width: 100%" clearable filterable>
                                <el-option v-for="(item, i) in ['选项1', '选项2']" :key="i" :label="item" :value="i" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="MAC地址" prop="select">
                            <j-ip-input v-model="dgmxForm.xxx" />
                        </el-form-item>
                    </el-form>
                </el-row>
            </el-card>

            <el-card shadow="hover">
                <label slot="header">搜索</label>
                <el-divider content-position="left">搜索表单样式</el-divider>
                <el-row>
                    <j-page>
                        <div slot="search">
                            <j-page-search title="时间范围">
                                <j-date-range :start.sync="query.xxx" :end.sync="query.xxx"/>
                            </j-page-search>
                            <j-page-search title="输入框">
                                <el-input v-model.trim="query.xxx" placeholder="请输入" clearable @keydown.native.enter="searchEvent" />
                            </j-page-search>
                            <j-page-search title="下拉框">
                                <el-select v-model="query.xxx" placeholder="请选择" clearable filterable>
                                    <el-option v-for="item in []" :key="item.value" :label="item.label" :value="item.value" />
                                </el-select>
                            </j-page-search>
                            <j-page-search title="级联框">
                                <j-grid-ctrl type="select" placeholder="请选择区域" v-model="query.xxx" />
                            </j-page-search>
                            <j-page-search title="MAC地址输入框">
                                <j-ip-input style="width: 300px;" v-model="query.xxx" />
                            </j-page-search>
                            <j-page-search title="城市选择">
                                <j-link-address v-model="query.xxx" placeholder="请选择地址" />
                            </j-page-search>
                            <j-page-search title="范围输入框">
                                <j-link-input :start.sync="query.xxx" :end.sync="query.xxx" />
                            </j-page-search>
                            <j-page-search title="字典选择下拉">
                                <j-dictionary v-model="query.xxx" code="GENDER" placeholder="请选择性别" />
                            </j-page-search>
                            <j-page-search title="字典选择单选">
                                <j-dictionary v-model="query.xxx" type="checkbox" code="GENDER" />
                            </j-page-search>
                            <j-page-search title="字典选择多选">
                                <j-dictionary v-model="query.yyy" type="checkbox" code="GENDER" multiple />
                            </j-page-search>
                            <el-button type="primary" icon="el-icon-search" @click="searchEvent">查询</el-button>
                        </div>
                    </j-page>
                </el-row>
            </el-card>

            <el-card shadow="hover">
                <label slot="header">列表</label>
                <el-divider content-position="left">列表样式</el-divider>
                <el-row>
                    <el-table :data="tableData" style="width: 700px;" stripe>
                        <el-table-column
                                prop="date"
                                label="日期"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="name"
                                label="姓名"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="address"
                                label="地址">
                        </el-table-column>
                    </el-table>
                </el-row>
            </el-card>

            <el-card shadow="hover" style="height: 300px;">
                <label slot="header">抽屉样式</label>
                <el-button @click="showDrmx = true;DrmxBtn = '1'">打开单按钮样式</el-button>
                <el-button @click="showDrmx = true;DrmxBtn = 'n'">打开多按钮样式</el-button>
                <j-drawer title="侧边栏" :close.sync="showDrmx">
                    <div slot="header" style="padding: 10px;">
                        <el-input value="头部插槽" />
                    </div>
                    <j-drawer-label type="title" title="基本信息" />
                    <div style="padding-right: 30px;">
                        <j-drawer-label align="right" title="文本">文本文本</j-drawer-label>
                        <j-drawer-label align="right" title="空样式"></j-drawer-label>
                    </div>
                    <div v-if="DrmxBtn === 'n'" slot="footer" style="display: flex; width: 100%;">
                        <el-button @click="showDrmx = false">保存</el-button>
                        <el-button @click="showDrmx = false">支持多个按钮</el-button>
                        <el-button @click="showDrmx = false">支持多个按钮</el-button>
                    </div>
                    <el-button v-else slot="footer" @click="showDrmx = false">单按钮</el-button>
                </j-drawer>
            </el-card>

            <el-card shadow="hover">
                <label slot="header">弹窗样式</label>
                <el-button @click="showDgmx = true">打开弹窗</el-button>
            </el-card>
        </div>

        <el-dialog v-if="showDgmx" :title="dgmxTypeMap[dgmxType]" :visible.sync="showDgmx" width="500px" top="15%" :close-on-click-modal="false">
            <el-form ref="dgmxDom" :model="dgmxForm" :rules="dgmxRule" :label-width="dgmxFormLabelWidth">
                <el-form-item label="输入框" prop="input">
                    <el-input v-model.trim="dgmxForm.input" placeholder="请输入" maxlength="10" show-word-limit clearable />
                </el-form-item>
                <el-form-item label="描述" prop="description">
                    <el-input v-model.trim="dgmxForm.description" type="textarea" :rows="3" placeholder="请输入描述" maxlength="200" show-word-limit clearable />
                </el-form-item>
                <el-form-item label="选择" prop="select">
                    <el-select v-model="dgmxForm.select" placeholder="请选择" style="width: 100%" clearable filterable>
                        <el-option v-for="(item, i) in ['选项1', '选项2']" :key="i" :label="item" :value="i" />
                    </el-select>
                </el-form-item>
            </el-form>
            <template slot="footer">
                <el-button type="primary" @click="checkDgmxEvent('saveDgmxData')" :loading="submitLoad">保存</el-button>
                <el-button @click="showDgmx = false">取消</el-button>
            </template>
        </el-dialog>
    </j-page>
</template>

<script>
    import PageMixins from "../../components/JComponents/JPage/mixins/PageMixins";
    import DialogMixins from "../../components/JComponents/JPage/mixins/DialogMixins";
    import DrawerMixins from "../../components/JComponents/JPage/mixins/DrawerMixins";
    import PaginationMixins from "../../components/JComponents/JPage/mixins/PaginationMixins";
    export default {
        name: "JStyleDemo",
        mixins: [PageMixins, DialogMixins, DrawerMixins, PaginationMixins],
        data() {
            return {
                color: ['', 1,2,3,4,5],
                showDrmx: false,
                DrmxBtn: '1',
                disabled: false,
                tableData: [{
                    date: '2016-05-02',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                }, {
                    date: '2016-05-04',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1517 弄'
                }, {
                    date: '2016-05-01',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1519 弄'
                }, {
                    date: '2016-05-03',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1516 弄'
                }]
            }
        },
        created() {

        },
        methods: {}
    }
</script>

<style lang="scss">
    .j-style-demo-layout {
        position: relative;
        .j-style-demo-layout-srcoll {
            height: 100%;
            overflow-y: auto;
            overflow-x: hidden;
        }
        .el-card {
            position: relative;
            margin-bottom: 50px;
        }
        .margin10 {
            margin: 10px 0;
        }
    }
</style>
